// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2tAPMFQ2x6fFfsMll5IeP1","close":"_1PqlTtJh4uJZByQNDLWWj","checkboxes":"_3ccxkdptrdkW91mrcTpJr6","checkbox":"_3IOGFgHs6rrMMJUrF0UVeW","checboxIcon":"zEb4ktCb5AH8GId4bc-oj","action":"_377aTNzeqbms3FfFd-lzm1"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/ConnectWithCollegeModal/ConnectWithCollegeModal.css
// module id = 378
// module chunks = 58